import React, { ReactNode } from 'react';
import { Card } from 'antd';
import './NewImageCard.less';

export type NewImageCardProps = {
  image?: string;
  videoComponent?: ReactNode | null;
  dotMenu?: ReactNode | null;
  coverHeight?: any;
  coverWidth?: any;
  onClick?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const TNewImageCard: React.FC<NewImageCardProps> = ({
  children,
  image,
  coverHeight,
  coverWidth,
  videoComponent,
  dotMenu,
  ...props
}) => {
  const renderImageSection = () => {
    return (
      <div className="t-newImageCardCoverImgWrapper">
        {dotMenu}
        <img
          style={{ height: coverHeight, width: coverWidth }}
          src={image}
          className="t-newImageCardCoverImg"
          alt="Image cover"
        />
      </div>
    );
  };
  const renderVideoSection = () => {
    return (
      <div style={{ height: coverHeight, width: coverWidth }}>
        {videoComponent}
      </div>
    );
  };

  return (
    <Card
      cover={
        <>
          {image && renderImageSection()}
          {videoComponent && renderVideoSection()}
        </>
      }
      className="t-newImageCardContainer"
      bodyStyle={{ padding: '16px' }}
    >
      {children}
    </Card>
  );
};

export default TNewImageCard;
